<ion-content>
  <nav class="side-menu" aria-label="Charity menu">
    <header class="sm-hero">
      <button type="button" class="sm-close" (click)="closeMenu()" aria-label="Close menu">
        <ion-icon name="close" aria-hidden="true"></ion-icon>
      </button>

      <div class="sm-avatar is-logo">
        <app-charity-avatar [avatarUrl]="_imageUrl" (upload)="updateImage($event)"></app-charity-avatar>
        <label class="sm-avatar-badge" for="single" aria-label="Change charity logo">
          <ion-icon name="camera" aria-hidden="true"></ion-icon>
        </label>
      </div>

      <h2 class="sm-name">{{ charityName }}</h2>
      <span class="sm-role">{{ roleLabel }}</span>
    </header>

    <section class="sm-switches" aria-label="Portals">
      <button type="button" class="sm-switch" (click)="switchToUser()">
        <span class="sm-switch-icon" aria-hidden="true"><ion-icon name="person"></ion-icon></span>
        <span>
          <span class="sm-switch-title">Switch to User Portal</span>
          <span class="sm-switch-note">Give and browse as yourself</span>
        </span>
        <ion-icon name="swap-horizontal" aria-hidden="true"></ion-icon>
      </button>
    </section>

    <section class="sm-section" aria-labelledby="sm-activity">
      <h3 class="sm-eyebrow" id="sm-activity">Activity</h3>
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row" (click)="goToDonationHistory()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="gift-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Donation History</span>
              <span class="sm-row-note">Gifts your charity has received</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToRecurringDonations()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="repeat-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Recurring Donations</span>
              <span class="sm-row-note">Manage donation subscriptions</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToOrders()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="receipt-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Orders</span>
              <span class="sm-row-note">Marketplace orders</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToFollowers()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="people-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">My Followers</span>
              <span class="sm-row-note">People following your charity</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
      </ul>
    </section>

    @if (canManageTeam) {
      <section class="sm-section" aria-labelledby="sm-manage">
        <h3 class="sm-eyebrow" id="sm-manage">Manage</h3>
        <ul class="sm-list">
          @if (canManageDonations) {
            <li>
              <button type="button" class="sm-row" (click)="goToAccountManagement()">
                <span class="sm-row-icon" aria-hidden="true"><ion-icon name="card-outline"></ion-icon></span>
                <span class="sm-row-text">
                  <span class="sm-row-title">Stripe Connect</span>
                  <span class="sm-row-note">Manage your Stripe account</span>
                </span>
                <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
              </button>
            </li>
          }
          <li>
            <button type="button" class="sm-row" (click)="goToTeamManagement()">
              <span class="sm-row-icon" aria-hidden="true"><ion-icon name="person-add-outline"></ion-icon></span>
              <span class="sm-row-text">
                <span class="sm-row-title">Team Management</span>
                <span class="sm-row-note">Invite and manage team members</span>
              </span>
              <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
            </button>
          </li>
          <li>
            <button type="button" class="sm-row" (click)="goToSettings()">
              <span class="sm-row-icon" aria-hidden="true"><ion-icon name="settings-outline"></ion-icon></span>
              <span class="sm-row-text">
                <span class="sm-row-title">Settings</span>
                <span class="sm-row-note">Manage permissions and settings</span>
              </span>
              <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
            </button>
          </li>
        </ul>
      </section>
    }

    <footer class="sm-footer">
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row is-danger" (click)="signOut()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="log-out-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Log Out</span>
            </span>
            <span aria-hidden="true"></span>
          </button>
        </li>
      </ul>
    </footer>
  </nav>
</ion-content>
